import { PublicLayout } from "@/components/layout/PublicLayout";
import { FloatingCard } from "@/components/primitives/FloatingCard";

export default function Datenschutz() {
	return (
		<PublicLayout>
			<article className="mx-auto w-full max-w-2xl px-4 py-8">
				<FloatingCard className="p-6 sm:p-8">
				<h1 className="text-2xl font-semibold tracking-tight">Datenschutzerklärung</h1>
				<p className="mt-3 text-sm text-fg-muted">
					Gültig für die Website und den Dienst <span className="text-fg">Kartenwerk</span>.
				</p>

				<section className="mt-10 space-y-4">
					<h2 className="text-xl font-semibold tracking-tight">1. Datenschutz auf einen Blick</h2>

					<h3 className="text-lg font-semibold">Allgemeine Hinweise</h3>
					<p className="text-fg-muted">
						Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
						personenbezogenen Daten passiert, wenn Sie diese Website besuchen oder den Dienst
						Kartenwerk nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich
						identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz
						entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
					</p>

					<h3 className="text-lg font-semibold">Datenerfassung auf dieser Website</h3>
					<p className="text-fg-muted">
						<strong className="text-fg">Wer ist verantwortlich für die Datenerfassung?</strong>
						<br />
						Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
						Kontaktdaten können Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle“ in
						dieser Datenschutzerklärung entnehmen.
					</p>
					<p className="text-fg-muted">
						<strong className="text-fg">Wie erfassen wir Ihre Daten?</strong>
						<br />
						Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen (z. B.
						E-Mail-Adresse und Name bei der Registrierung, Karteninhalte und Metadaten). Andere
						Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch
						unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B.
						Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
					</p>
					<p className="text-fg-muted">
						<strong className="text-fg">Wofür nutzen wir Ihre Daten?</strong>
						<br />
						Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website und
						des Dienstes zu gewährleisten. Andere Daten verarbeiten wir, um Ihr Konto zu
						betreiben, Karten und Ebenen zu speichern und freizugeben sowie die Anmeldung
						durchzuführen.
					</p>
					<p className="text-fg-muted">
						<strong className="text-fg">Welche Rechte haben Sie bezüglich Ihrer Daten?</strong>
						<br />
						Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und
						Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem
						ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine
						Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung
						jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
						bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen
						Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der
						zuständigen Aufsichtsbehörde zu.
					</p>
				</section>

				<section className="mt-10 space-y-4">
					<h2 className="text-xl font-semibold tracking-tight">
						2. Hosting und Content Delivery Networks (CDN)
					</h2>

					<h3 className="text-lg font-semibold">Hosting</h3>
					<p className="text-fg-muted">
						Diese Website und der Dienst Kartenwerk werden auf{" "}
						<a
							href="https://www.cloudflare.com/de-de/"
							target="_blank"
							rel="noopener noreferrer"
							className="text-teal-500 hover:text-teal-400"
						>
							Cloudflare Workers
						</a>{" "}
						gehostet.
					</p>
					<p className="text-fg-muted">
						<strong className="text-fg">Anbieter:</strong>
						<br />
						Cloudflare Germany GmbH
						<br />
						c/o Design Offices München Atlas
						<br />
						Rosenheimer Straße 143C, 8. Stock
						<br />
						81671 München, Deutschland
					</p>
					<p className="text-fg-muted">
						Cloudflare verarbeitet beim Aufruf der Seite technisch erforderliche
						Verbindungsdaten (z. B. IP-Adresse, Browsertyp, Zeitpunkt des Zugriffs), um die
						Auslieferung der Inhalte und die Sicherheit gegen Angriffe zu gewährleisten.
					</p>
					<p className="text-fg-muted">
						Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem
						stabilen und sicheren Betrieb dieser Website) sowie Art. 6 Abs. 1 lit. b DSGVO,
						soweit die Verarbeitung zur Vertragserfüllung gegenüber angemeldeten Nutzern
						erforderlich ist.
					</p>
					<p className="text-fg-muted">
						Mit Cloudflare besteht ein{" "}
						<strong className="text-fg">Auftragsverarbeitungsvertrag (AVV)</strong>, der die
						Einhaltung der datenschutzrechtlichen Vorgaben der DSGVO gewährleistet.
					</p>
					<p className="text-fg-muted">
						Im Rahmen des Dienstes Kartenwerk werden u. a. folgende Cloudflare-Dienste
						eingesetzt:
					</p>
					<ul className="list-disc space-y-1 pl-5 text-fg-muted">
						<li>Workers (Anwendungslogik und Auslieferung der Website)</li>
						<li>D1 (relationale Datenbank)</li>
						<li>CDN / DNS (Auslieferung und Absicherung des Datenverkehrs)</li>
					</ul>
					<p className="text-fg-muted">
						Weitere Informationen zum Datenschutz bei Cloudflare:{" "}
						<a
							href="https://www.cloudflare.com/privacypolicy/"
							target="_blank"
							rel="noopener noreferrer"
							className="text-teal-500 hover:text-teal-400"
						>
							https://www.cloudflare.com/privacypolicy/
						</a>
						.
					</p>
				</section>

				<section className="mt-10 space-y-4">
					<h2 className="text-xl font-semibold tracking-tight">
						3. Allgemeine Hinweise und Pflichtinformationen
					</h2>

					<h3 className="text-lg font-semibold">Datenschutz</h3>
					<p className="text-fg-muted">
						Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
						Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den
						gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
					</p>
					<p className="text-fg-muted">
						Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten
						erhoben. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben
						und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das
						geschieht.
					</p>
					<p className="text-fg-muted">
						Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der
						Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz
						der Daten vor dem Zugriff durch Dritte ist nicht möglich.
					</p>

					<h3 className="text-lg font-semibold">Hinweis zur verantwortlichen Stelle</h3>
					<p className="text-fg-muted">
						Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
					</p>
					<p className="text-fg-muted">
						Alexander Abelt
						<br />
						Kettenburg 14
						<br />
						27374 Visselhövede
					</p>
					<p className="text-fg-muted">
						Telefon: 04262 / 790 15 99
						<br />
						E-Mail:{" "}
						<a
							href="mailto:datenschutz@mattschach.com"
							className="text-teal-500 hover:text-teal-400"
						>
							datenschutz@mattschach.com
						</a>
					</p>
					<p className="text-fg-muted">
						Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
						gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
						personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
					</p>

					<h3 className="text-lg font-semibold">Speicherdauer</h3>
					<p className="text-fg-muted">
						Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt
						wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die
						Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen
						oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht,
						sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
						personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
						Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall
						dieser Gründe.
					</p>

					<h3 className="text-lg font-semibold">
						Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung
					</h3>
					<p className="text-fg-muted">
						Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
						personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO. Sind Ihre
						Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen
						erforderlich, verarbeiten wir Ihre Daten auf Grundlage von Art. 6 Abs. 1 lit. b
						DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer
						rechtlichen Verpflichtung erforderlich sind, auf Grundlage von Art. 6 Abs. 1 lit. c
						DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten
						Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall
						einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen dieser
						Datenschutzerklärung informiert.
					</p>

					<h3 className="text-lg font-semibold">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
					<p className="text-fg-muted">
						Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung
						möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die
						Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
						unberührt.
					</p>

					<h3 className="text-lg font-semibold">Widerspruchsrecht (Art. 21 DSGVO)</h3>
					<p className="text-fg-muted">
						WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO
						ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN
						SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH
						EINZULEGEN. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DER EINE VERARBEITUNG BERUHT,
						ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR
						IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR
						KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE
						INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER
						GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN.
					</p>

					<h3 className="text-lg font-semibold">Beschwerderecht bei der Aufsichtsbehörde</h3>
					<p className="text-fg-muted">
						Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei
						einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen
						Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu.
					</p>

					<h3 className="text-lg font-semibold">Recht auf Datenübertragbarkeit</h3>
					<p className="text-fg-muted">
						Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in
						Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in
						einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die
						direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt
						dies nur, soweit es technisch machbar ist.
					</p>

					<h3 className="text-lg font-semibold">Auskunft, Berichtigung und Löschung</h3>
					<p className="text-fg-muted">
						Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf
						unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren
						Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf
						Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
						personenbezogene Daten können Sie sich jederzeit an uns wenden.
					</p>

					<h3 className="text-lg font-semibold">Recht auf Einschränkung der Verarbeitung</h3>
					<p className="text-fg-muted">
						Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
						Daten zu verlangen. Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf
						Einschränkung der Verarbeitung besteht insbesondere, wenn Sie die Richtigkeit der
						Daten bestreiten, die Verarbeitung unrechtmäßig ist, wir die Daten nicht mehr
						benötigen Sie sie aber zur Geltendmachung von Rechtsansprüchen brauchen, oder Sie
						Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben.
					</p>

					<h3 className="text-lg font-semibold">SSL- bzw. TLS-Verschlüsselung</h3>
					<p className="text-fg-muted">
						Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
						vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
						Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf
						„https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
					</p>

					<h3 className="text-lg font-semibold">Widerspruch gegen Werbe-E-Mails</h3>
					<p className="text-fg-muted">
						Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur
						Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien
						wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich
						rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa
						durch Spam-E-Mails, vor.
					</p>
				</section>

				<section className="mt-10 space-y-4">
					<h2 className="text-xl font-semibold tracking-tight">
						4. Datenerfassung auf dieser Website
					</h2>

					<h3 className="text-lg font-semibold">Cookies</h3>
					<p className="text-fg-muted">
						Auf dieser Website werden{" "}
						<strong className="text-fg">keine Cookies von Drittanbietern</strong> und keine
						Tracking- oder Analyse-Cookies eingesetzt.
					</p>
					<p className="text-fg-muted">
						Es kommen technisch notwendige Cookies von Cloudflare zum Einsatz, die für den
						sicheren Betrieb der Seite (z. B. Bot- und DDoS-Schutz) erforderlich sind. Eine
						Einwilligung ist hierfür nicht erforderlich.
					</p>
					<p className="text-fg-muted">
						<strong className="text-fg">Session-Cookies (Better Auth)</strong>
						<br />
						Nach erfolgreichem Login setzen wir technisch notwendige Session-Cookies (HttpOnly,
						SameSite=Lax, Secure bei HTTPS). Sie speichern ein Sitzungstoken und sind in der
						Regel bis zu 30 Tage gültig. Die Cookies sind erforderlich, um Sie als angemeldeten
						Nutzer zu erkennen und den Dienst bereitzustellen. Rechtsgrundlage ist Art. 6 Abs. 1
						lit. b DSGVO (Vertragserfüllung).
					</p>
					<p className="text-fg-muted">
						Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies
						informiert werden und Cookies nur im Einzelfall erlauben. Bei der Deaktivierung von
						Cookies kann die Funktionalität dieser Website – insbesondere der Login –
						eingeschränkt sein.
					</p>

					<h3 className="text-lg font-semibold">Registrierung und Login</h3>
					<p className="text-fg-muted">
						Die Registrierung ist nur per Einladung möglich. Bei der Kontoerstellung und
						Anmeldung verarbeiten wir E-Mail-Adresse, optionalen Anzeigenamen sowie ein
						Passwort (nur in gehashter Form gespeichert). Optional können Sie einen persönlichen
						Zugangslink (Login-Token) erzeugen, der wie ein Lesezeichen ohne Passwort anmeldet.
					</p>
					<p className="text-fg-muted">
						Die Verarbeitung erfolgt zur Durchführung vorvertraglicher Maßnahmen und zur
						Erfüllung des Nutzungsvertrags (Art. 6 Abs. 1 lit. b DSGVO).
					</p>

					<h3 className="text-lg font-semibold">Kontodaten und Nutzungsinhalte</h3>
					<p className="text-fg-muted">
						Wenn Sie Kartenwerk nutzen, speichern wir die für den Dienst erforderlichen Daten,
						insbesondere:
					</p>
					<ul className="list-disc space-y-1 pl-5 text-fg-muted">
						<li>E-Mail-Adresse und optionaler Anzeigename</li>
						<li>Karten, Ebenen und Einträge (inkl. Geometrien, Titel, Beschreibungen)</li>
						<li>Freigaben (Share-Links, Rollen, Token)</li>
						<li>Einladungen und optionale Zugangslinks</li>
					</ul>
					<p className="text-fg-muted">
						Diese Daten verarbeiten wir, um den Dienst bereitzustellen (Art. 6 Abs. 1 lit. b
						DSGVO).
					</p>

					<h3 className="text-lg font-semibold">Ortssuche (Geocoding)</h3>
					<p className="text-fg-muted">
						Für die Ortssuche leiten wir Ihre Suchanfrage serverseitig an den Nominatim-Dienst
						von OpenStreetMap weiter. Dabei können Suchbegriffe und technische Verbindungsdaten
						verarbeitet werden. Die Nutzung erfolgt nur, wenn Sie die Ortssuche aktiv
						verwenden.
					</p>
					<p className="text-fg-muted">
						Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Funktionserbringung) bzw. Art. 6 Abs. 1
						lit. f DSGVO (berechtigtes Interesse an einer nutzbaren Kartensuche).
					</p>

					<h3 className="text-lg font-semibold">Kartendarstellung</h3>
					<p className="text-fg-muted">
						Zur Anzeige der Kartengrundlage werden Kartenkacheln von OpenFreeMap geladen. Dabei
						können technische Verbindungsdaten (z. B. IP-Adresse) an den jeweiligen
						Karten-Anbieter übertragen werden.
					</p>
					<p className="text-fg-muted">
						Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
						Darstellung von Karteninhalten).
					</p>

					<h3 className="text-lg font-semibold">Server-Log-Dateien</h3>
					<p className="text-fg-muted">
						Der Provider der Seiten (Cloudflare) erhebt und speichert automatisch Informationen
						in so genannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies
						können insbesondere sein:
					</p>
					<ul className="list-disc space-y-1 pl-5 text-fg-muted">
						<li>Browsertyp und Browserversion</li>
						<li>verwendetes Betriebssystem</li>
						<li>Referrer URL</li>
						<li>Hostname des zugreifenden Rechners</li>
						<li>Uhrzeit der Serveranfrage</li>
						<li>IP-Adresse</li>
					</ul>
					<p className="text-fg-muted">
						Eine Zusammenführung dieser Daten mit anderen Datenquellen wird von uns nicht zu
						Marketingzwecken vorgenommen. Die Erfassung erfolgt auf Grundlage von Art. 6 Abs. 1
						lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch
						fehlerfreien Darstellung und der Optimierung seiner Website.
					</p>

					<h3 className="text-lg font-semibold">Anfrage per E-Mail oder Telefon</h3>
					<p className="text-fg-muted">
						Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller
						daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der
						Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben
						wir nicht ohne Ihre Einwilligung weiter.
					</p>
					<p className="text-fg-muted">
						Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre
						Anfrage mit der Erfüllung eines Vertrags zusammenhängt, oder auf Grundlage von Art.
						6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der effektiven Bearbeitung von
						Anfragen).
					</p>
				</section>

				<section className="mt-10 space-y-4">
					<h2 className="text-xl font-semibold tracking-tight">5. Analyse-Tools und Werbung</h2>
					<p className="text-fg-muted">
						Wir setzen derzeit keine Drittanbieter-Analyse- oder Werbe-Tools (z. B. Google
						Analytics) auf Kartenwerk ein.
					</p>
				</section>

				<section className="mt-10 space-y-4">
					<h2 className="text-xl font-semibold tracking-tight">6. Plugins und Tools</h2>
					<p className="text-fg-muted">
						Neben den unter „Hosting“ genannten Cloudflare-Diensten und den für die
						Kartendarstellung bzw. Ortssuche erforderlichen Diensten binden wir keine
						Tracking-Skripte oder Social-Media-Widgets ein.
					</p>
				</section>
				</FloatingCard>
			</article>
		</PublicLayout>
	);
}
